import {
    GET_DATA_FAIL,
    GET_DATA_SUCCESS,
    GET_DATA_START,
    GET_QUARTER_DATA_START,
    GET_QUARTER_DATA_SUCCESS,
    GET_QUARTER_CHART_START,
    GET_QUARTER_CHART_SUCCESS,
    GET_QUARTER_DSP_CHART_START,
    GET_QUARTER_DSP_CHART_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_START,
    GET_QUARTER_TERRITORY_CHART_SUCCESS,
    GET_ASSET_PROFILE_START,
    GET_ASSET_PROFILE_SUCCESS,
    GET_TOPS_QUARTER_START,
    GET_TOPS_QUARTER_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS,
    GET_ISRC_DSP_CHART_START,
    GET_ISRC_DSP_CHART_SUCESS,
    GET_ISRC_CHART_DATE_START,
    GET_ISRC_CHART_DATE_SUCESS,
    GET_QUARTER_ACTIVITY_CHART_START,
    GET_QUARTER_ACTIVITY_CHART_SUCCESS,
    GET_IMPERSONATION_LIST_START,
    GET_IMPERSONATION_LIST_SUCCESS,
    SET_IMPERSONATION_LIST_START,
    SET_IMPERSONATION_LIST_SUCCESS,
    SET_AUDIOURL,
    SORT_TEMP_SHORTLIST,
    REQUEST_UPDATE_SHORTLIST,
    RECEIVE_UPDATE_SHORTLIST,
    REQUEST_AUTOCOMPLETE_SHORTLIST,
    RECEIVE_AUTOCOMPLETE_SHORTLIST,
    SELECT_TRACK,
    RECEIVE_SHORTLIST_DRAFT,
    REQUEST_SHORTLIST_DRAFT,  
    SET_SHORTLIST,
    SET_SHORTLIST_NAME,
    RECEIVE_CREATE_SHORTLIST,
    REQUEST_CREATE_SHORTLIST,
    REQUEST_SHORTLIST_ANALYSIS,
    RECEIVE_SHORTLIST_ANALYSIS,
    MODIFY_SHORTLIST,
    SET_TAB,
    SET_SHORTLIST_ISRC,
    SET_CATALOG_FILTER,
    SET_CATALOG_SELECTED,
    SET_GENRES_SELECTED,
    REQUEST_READY_SHORTLIST,
    RECEIVE_READY_SHORTLIST,
    REQUEST_DELETE_SHORTLIST,
    RECEIVE_DELETE_SHORTLIST,
    CLEAR_SHORTLIST,
    GET_UPC_DATA,
    UPC_DATA_SUCCESS,
    GET_RELEASE_DATA,
    RELEASE_DATA_SUCCESS,
    REQUEST_NAME_SHORTLIST,
    RECEIVE_NAME_SHORTLIST,
    REQUEST_GENRE_SHORTLIST,
    RECEIVE_GENRE_SHORTLIST,
    REQUEST_SUBGENRE_SHORTLIST,
    RECEIVE_SUBGENRE_SHORTLIST,
    SET_SHORTLIST_BY_STATE,
    SET_UPCS_TERRITORIES,
    REQUEST_TERRITORY_CHANGE,
    REQUEST_TERRITORY_CHANGE_SUCCESS,
    REQUEST_ASSET_TAGS_LIST,
    RECEIVE_ASSET_TAGS_LIST,
    REQUEST_AUTOCOMPLETE_TAGS,
    RECEIVE_AUTOCOMPLETE_TAGS,
    REQUEST_SAVE_TAGS,
    RECEIVE_SAVE_TAGS,
    SET_MOODS,
    REQUEST_PUBLISH_PRODUCT,
    REQUEST_PUBLISH_PRODUCT_SUCCESS,
    SET_UPCS_PUBLISH,
    REQUEST_CATALOG_CHANGE,
    REQUEST_CATALOG_CHANGE_SUCCESS,
    SET_CATALOG_CODES,
    REQUEST_MASS_PRODUCT_CHANGE,
    REQUEST_MASS_PRODUCT_SUCCESS,
    SET_MASS_PRODUCT_CODES,
    REQUEST_PRODUCTS_UPDATE_LIST,
    REQUEST_PRODUCTS_UPDATE_SUCCESS,
    SELECT_PRODUCT_FOR_UPDATE,
    REQUEST_SINGLE_PRODUCT_CHANGE,
    REQUEST_SINGLE_PRODUCT_CHANGE_SUCCESS,
    SET_SHORTLIST_GENRE,
    SET_SHORTLIST_SUBGENRE,
    REQUEST_UPDATE_PRODUCT,
    SET_UPCS_UPDATE,
    REQUEST_UPDATE_PRODUCT_SUCCESS,
    REQUEST_UPDATE_ASSET,
    REQUEST_UPDATE_ASSET_SUCCESS,
    SET_ISRCS_UPDATE,

    REQUEST_UPDATE_LOP,
    REQUEST_UPDATE_LOP_SUCCESS,
    SET_UPCS_LOP_UPDATE,

    GET_SYNC_DATA,
    GET_SYNC_DATA_SUCCESS,
    SELECT_SYNC_TRACK,
    SET_TAB_SYNC,

    REQUEST_UPDATE_LYRICIST,
    REQUEST_UPDATE_LYRICIST_SUCCESS,
    SET_UPCS_LYRICIST_UPDATE,
    SET_FILTER_GENRE,
    SET_FILTER_TITLE,
    SET_FILTER_ISRC,
    GET_ML_TAGS,
    GET_ML_TAGS_SUCCESS,
    SET_TAG_ML_SHOW,
    SET_TAG_ML_SHOW_SUCCESS,
    SET_TAG_ML_VERIFIED,
    SET_TAG_ML_VERIFIED_SUCCESS,
    SET_ML_ASSET_SELECTED
    
} from '../Types';
import axios from 'axios';
import { getUser } from './authActions'
const SERVER_URL = "";


export const actionCreators = {


    requestAssetTagslist: (page)  => async (dispatch, getState) => {
        if (page !== getState().data.currentPage_Tags) {
            dispatch({ type: REQUEST_ASSET_TAGS_LIST });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);         
            const url = `api/data/getAssetTagsList?page=${page}&withouttags=True`;
            var request = new Request(url, {
                headers
            });

            const response = await fetch(request);
            const data = await response.json();

            dispatch({ type: RECEIVE_ASSET_TAGS_LIST, data });

          
        }

    },
    requestTags: (tagType) => async (dispatch, getState) => {
        var reload = false;
        switch (tagType) {
            case "mood":
                reload = getState().data.moods.length === 0 
                break;
            case "environmental":
                reload = getState().data.environmental.length === 0
                break;
            case "audio_quality":
                reload = getState().data.audio_quality.length === 0
                break;
            case "audio":
                reload = getState().data.audio_tags.length === 0
                break;
            case "instrument":
                reload = getState().data.instruments.length === 0
                break;
            default:
        }


        if (reload) {
            dispatch({ type: REQUEST_AUTOCOMPLETE_TAGS, tagType });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/GetTagsByType?type=${tagType}`;
            var request = new Request(url, {
                headers
            });

            const response = await fetch(request);
            const data = await response.json();

            dispatch({ type: RECEIVE_AUTOCOMPLETE_TAGS, data, tagType });

           
        }
    }
    ,
    SetTagToISRC: (tags, isrc) => async (dispatch, getState) => {


        var payload = {
            isrc: isrc,
            tags: tags
        }

        if (true) {
            dispatch({ type: REQUEST_SAVE_TAGS });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/SetTagsIsrc`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(payload)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type:RECEIVE_SAVE_TAGS, data: data });
            } catch (e) {
                console.error(e);
            }
        }

    },
    publishProduct: (upc) => async (dispatch, getState) => {
        if (upc && upc !== "" && getState().data.requestedPublishUPC !== upc && !getState().data.isPublishingProduct) {
            dispatch({ type: REQUEST_PUBLISH_PRODUCT, upc });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/publishProductByUpc`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(upc)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_PUBLISH_PRODUCT_SUCCESS, data, upc });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    updateProduct: (upc) => async (dispatch, getState) => {
        if (upc && upc !== "" && getState().data.requestedUpdateUPC !== upc && !getState().data.isUpdatingProduct) {
            dispatch({ type: REQUEST_UPDATE_PRODUCT, upc });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/updateProductByUpc`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(upc)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_UPDATE_PRODUCT_SUCCESS, data, upc });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    updateProductLoP: (upc) => async (dispatch, getState) => {
        if (upc && upc !== "" && getState().data.requestedUpdateUPCLoP !== upc && !getState().data.isUpdatingProductLoP) {
            dispatch({ type: REQUEST_UPDATE_LOP, upc });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/updateLoPByUpc`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(upc)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_UPDATE_LOP_SUCCESS, data, upc });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    updateLyricistFromComposerByUpc: (upc) => async (dispatch, getState) => {
        if (upc && upc !== "" && getState().data.requestedUpdateUPCLyricist !== upc && !getState().data.isUpdatingProductLyricist) {
            dispatch({ type: REQUEST_UPDATE_LYRICIST, upc });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/updateLyricistFromComposerByUpc`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(upc)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_UPDATE_LYRICIST_SUCCESS, data, upc });
            } catch (e) {
                console.error(e);
            }
        }
    },
    updateAsset: (isrc) => async (dispatch, getState) => {
        if (isrc && isrc !== "" && getState().data.requestedUpdateISRC !== isrc && !getState().data.isUpdatingAsset) {
            dispatch({ type: REQUEST_UPDATE_ASSET, isrc });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/updateAssetsByISRC`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(isrc)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_UPDATE_ASSET_SUCCESS, data, isrc });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    saveTerritory: (upc, territory) => async (dispatch, getState) => {
        if (upc && upc !== "" && getState().data.requestedTerritoryUPC !== upc && !getState().data.isSavingTerritory) {
            dispatch({ type: REQUEST_TERRITORY_CHANGE, upc, territory });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/setTerritories?queryType=${territory}`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(upc)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_TERRITORY_CHANGE_SUCCESS, data, upc, territory });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    saveCatalog: (code, catalog) => async (dispatch, getState) => {
        if (code && code !== "" && getState().data.requestedCatalogCode !== code && !getState().data.isSavingCatalog) {
            dispatch({ type: REQUEST_CATALOG_CHANGE, code, catalog });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/setCatalog?catalog=${catalog}`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(code)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_CATALOG_CHANGE_SUCCESS, data, code, catalog });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    saveMassProductChanges: (code,_prop, _value) => async (dispatch, getState) => {
        if (code && code !== "" && getState().data.requestedMassProductCode !== code && !getState().data.isSavingMassProductChange) {
            dispatch({ type: REQUEST_MASS_PRODUCT_CHANGE, code, _prop, _value });
            var data = { upcs: [code], prop: _prop, value: _value };
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/setProductValue`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_MASS_PRODUCT_SUCCESS, data, code, _prop, _value });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    setListName: (shortlist, name) => async (dispatch, getState) => {

        if (true) {
            dispatch({ type: REQUEST_NAME_SHORTLIST });
            var headers = new Headers();
            var data = { "name": name };
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/SetShortListName?id=${shortlist}`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(name)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
                dispatch({ type: RECEIVE_NAME_SHORTLIST, data, shortlist });
            } catch (e) {
                console.error(e);
            }
        }

    },
    setListGenre: (shortlist, name) => async (dispatch, getState) => {

        if (true) {
            dispatch({ type: REQUEST_GENRE_SHORTLIST });
            var headers = new Headers();
            var data = { "name": name };
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/SetShortListGenre?id=${shortlist}`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(name)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
                dispatch({ type: RECEIVE_GENRE_SHORTLIST, data, shortlist });
            } catch (e) {
                console.error(e);
            }
        }

    },
    setListSubGenre: (shortlist, name) => async (dispatch, getState) => {

        if (true) {
            dispatch({ type: REQUEST_SUBGENRE_SHORTLIST });
            var headers = new Headers();
            var data = { "name": name };
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/SetShortListSubGenre?id=${shortlist}`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(name)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
                dispatch({ type: RECEIVE_SUBGENRE_SHORTLIST, data, shortlist });
            } catch (e) {
                console.error(e);
            }
        }

    },
    setProductProp: (code,_prop,_value) => async (dispatch, getState) => {

        if (true) {
            dispatch({ type: REQUEST_SINGLE_PRODUCT_CHANGE, code, _prop, _value });
            var data = { upcs: [code], prop: _prop, value: _value };
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/setSingleProductValue`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: REQUEST_SINGLE_PRODUCT_CHANGE_SUCCESS, data, code, _prop, _value });
            } catch (e) {
                console.error(e);
            }
        }

    },
    getReleaseData: (upcs) => async (dispatch, getState) => {
        if (upcs && upcs !== "" && getState().data.upcsRelease !== upcs) {
            dispatch({ type: GET_RELEASE_DATA, upcs });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/getReleaseData`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(upcs)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: RELEASE_DATA_SUCCESS, data, upcs });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    getUpcData: (upcs,query) => async (dispatch, getState) => {
        if ((query === "PublishedProducts" || query === "Jazz" || query === "ShortListsInProgress" || query === "ProductsForUpdate" || query ==="DspValue") ||(   upcs && upcs !== "" && getState().data.upcs !== upcs)) {            
            dispatch({ type: GET_UPC_DATA, upcs });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/genericList?queryType=${query}`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(upcs)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
               
                dispatch({ type: UPC_DATA_SUCCESS, data, upcs });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    getSyncData: (nameQuery) => async (dispatch, getState) => {       
        if (nameQuery &&  (getState().data.trackNameQuery ? getState().data.trackNameQuery.title !== nameQuery.title || getState().data.trackNameQuery.genre !== nameQuery.genre|| getState().data.trackNameQuery.isrcs !== nameQuery.isrcs : true)) 
        {
            dispatch({ type: GET_SYNC_DATA, nameQuery });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/getSyndDataByFilter`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(nameQuery)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: GET_SYNC_DATA_SUCCESS, data, nameQuery });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    clearShortList: () => (dispatch) => dispatch({ type: CLEAR_SHORTLIST }),
    setListReady: (shortlist,type) => async (dispatch, getState) => {
       
        if (true) {           
            dispatch({ type: REQUEST_READY_SHORTLIST });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/SetShortListReady?id=${shortlist}&type=${type}`;
            var request = new Request(url, {
                method: 'POST',
                headers
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
                dispatch({ type: RECEIVE_READY_SHORTLIST, data });
            } catch (e) {
                console.error(e);
            }
        }

    }
    ,
    setListDelete: () => async (dispatch, getState) => {
        let shortlist = getState().data.shortlistDetail;
        if (true) {


            let data = shortlist;
            dispatch({ type: REQUEST_DELETE_SHORTLIST });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/DeleteShortList?id=${getState().data.selectedShortlist}`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
                dispatch({ type: RECEIVE_DELETE_SHORTLIST, data });
            } catch (e) {
                console.error(e);
            }
        }

    }
    ,
    clearTags: () => (dispatch) => dispatch({ type: "CLEAR_TAGS" }),
    setMLAssetSelected: (asset) => (dispatch) => dispatch({ type: SET_ML_ASSET_SELECTED, asset: asset}),
    setTerritoriesUPCs: (data, territory) => (dispatch) => dispatch({ type: SET_UPCS_TERRITORIES, data: data, territory: territory }),
    setCatalogCodes: (data, catalog) => (dispatch) => dispatch({ type: SET_CATALOG_CODES, data: data, catalog: catalog }),  
    setMassProductChangeCodes: (data, _prop, _value) => (dispatch) => dispatch({ type: SET_MASS_PRODUCT_CODES, data: data, _prop: _prop, _value: _value }),  
    setPublishUPCs: (data) => (dispatch) => dispatch({ type: SET_UPCS_PUBLISH, data: data }),
    setUpdateUPCs: (data) => (dispatch) => dispatch({ type: SET_UPCS_UPDATE, data: data }),  
    setUpdateISRCs: (data) => (dispatch) => dispatch({ type: SET_ISRCS_UPDATE, data: data }),
    setUpdateUPCsLoP: (data) => (dispatch) => dispatch({ type: SET_UPCS_LOP_UPDATE, data: data }),
    setUpdateUPCsLyricist: (data) => (dispatch) => dispatch({ type: SET_UPCS_LYRICIST_UPDATE, data: data }),  
    setGenresSelected: (filtered) => (dispatch) => dispatch({ type: SET_GENRES_SELECTED, filtered: filtered }),   
    setCatalogsSelected: (filtered) => (dispatch) => dispatch({ type: SET_CATALOG_SELECTED, filtered: filtered }),
    setCatalogueFilter: (filtered) => (dispatch) => dispatch({ type: SET_CATALOG_FILTER, filtered: filtered }),
    SetShortlistIsrc: (shortlist) => (dispatch) => dispatch({ type: SET_SHORTLIST_ISRC, isrc: shortlist }),
    SetMood: (data) => (dispatch) => dispatch({ type:SET_MOODS, data: data }),
    SetEnvironmental: (data) => (dispatch) => dispatch({type:'SET_ENVIROMENTAL', data: data}),
    SetAudioQuality: (data) => (dispatch) => dispatch({type:'SET_AUDIO_QUALITY', data: data}),
    SetAudioTag: (data) => (dispatch) => dispatch({type:'SET_AUDIO_TAGS', data: data}),
    SetInstruments: (data) => (dispatch) => dispatch({type:'SET_INSTRUMENTS', data: data}),
    SetTagModel: (data) => (dispatch) => dispatch({ type: 'SET_TAG_MODEL', data: data }),
    setFilterGenre: (data) => (dispatch) => dispatch({ type:SET_FILTER_GENRE, data:data }),
    setFilterTitle: (data) => (dispatch) => dispatch({ type: SET_FILTER_TITLE, data: data }),
    setFilterISRC: (data) => (dispatch) => dispatch({ type: SET_FILTER_ISRC, data: data }),
    CreateShortListFromISRC: () => async (dispatch, getState) => {
        let idToken = localStorage.getItem('idToken');
        let user = getUser(idToken);
      
        let name = getState().data.shortListName;
        let temp = getState().data.shortListISRC;

        var payload = {
            name: name,
            user: user.username,
            notes: temp
        }

        if (true) {

            dispatch({ type: REQUEST_CREATE_SHORTLIST });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/CreateShortlistFromISRC`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(payload)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
                dispatch({ type: RECEIVE_CREATE_SHORTLIST, data });
            } catch (e) {
                console.error(e);
            }

        }

    },
    CreateShortList: () => async (dispatch, getState) => {
        let idToken = localStorage.getItem('idToken');
        let user = getUser(idToken);
       
        let name = getState().data.shortListName;
        let temp = getState().data.tempShortList;

        //change temp FugaID as long to String
        let tempWithStringFugaID = temp.map(item => ({
            ...item,
            fugaID: item.fugaID ? item.fugaID.toString() : item.fugaID
        }));

        var payload = {
            name: name,
            user: user.username,
            assets: tempWithStringFugaID
        }

        if (true) {           
         
            dispatch({ type: REQUEST_CREATE_SHORTLIST });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/CreateShortlist`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(payload)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
                dispatch({ type: RECEIVE_CREATE_SHORTLIST, data });
            } catch (e) {
                console.error(e);
            }
        }

    },
    SetShortlistName: (shortlist) => (dispatch) => dispatch({ type: SET_SHORTLIST_NAME, name: shortlist }),
    SetShortlistGenre: (shortlist) => (dispatch) => dispatch({ type: SET_SHORTLIST_GENRE, name: shortlist }),
    SetShortlistSubGenre: (shortlist) => (dispatch) => dispatch({ type: SET_SHORTLIST_SUBGENRE, name: shortlist }),
    selectTrack: (_id) => (dispatch) => {
        dispatch({ type: SELECT_TRACK, _id: _id });
    },
    selectSyncTrack: (_id) => (dispatch) => {
        dispatch({ type: SELECT_SYNC_TRACK, _id: _id });
    },
    selectProductForUpdate: (_id) => (dispatch) => {
        dispatch({ type: SELECT_PRODUCT_FOR_UPDATE, _id: _id });
    },
    requestShortListDetailDraft: (isReady)=> async (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading) 
        var reload = false;
        if (isReady) {
            reload = getState().data.selectedShortlistReady !== getState().data.requestedShortListReady
        } else {
            reload = getState().data.selectedShortlist !== getState().data.requestedShortList
        }
        if (reload) {

            dispatch({ type: REQUEST_SHORTLIST_DRAFT, isReady });
            var headers = new Headers();
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/GetShortListDraftById?id=${isReady ? getState().data.requestedShortListReady :  getState().data.selectedShortlist }`;
            var request = new Request(url, {
                headers
            });

            const response = await fetch(request);
            if (response.ok) {
                const data = await response.json();
                dispatch({ type: RECEIVE_SHORTLIST_DRAFT, data, isReady });
            } else if (response.status === 401) {
                getState().auth.isLogin = false;
            }
           

           
        }


    },
    requestShortList: (isReady,_type) => async (dispatch, getState) => {
        var reload = false;
        if (getState().data.forceUpdate === true) {
            reload = true;
        } else {
            if (isReady) {
                reload = getState().data.shortListsReady.length === 0 && !getState().data.isLoadingReadyShortLists && !getState().data.firstLoad
            } else {
                switch (_type) {
                    case "Amend":
                        reload = getState().data.shortListsCorrections.length === 0 && !getState().data.isLoadingShortlists && !getState().data.firstLoad
                        break;

                    default:
                        reload = getState().data.shortLists.length === 0 &&  !getState().data.isLoadingShortlists && !getState().data.firstLoad
                }
                
            }
        }
        if (reload) {
            if (isReady) {
                dispatch({ type: REQUEST_AUTOCOMPLETE_SHORTLIST });
                var headers = new Headers();
                headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
                const url = `api/data/GetShortListDetails?isReady=${isReady}`;
                var request = new Request(url, {
                    headers
                });

                const response = await fetch(request);
                if (response.ok) {
                    const payload = await response.json();

                    dispatch({ type: RECEIVE_AUTOCOMPLETE_SHORTLIST, payload, isReady, _type });
                } else if (response.status === 401) {
                getState().auth.isLogin = false;
            }

            } else {
                dispatch({ type: REQUEST_AUTOCOMPLETE_SHORTLIST });
                var headers = new Headers();
                headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
                const url = `api/data/GetShortListDetails?isReady=${isReady}`;
                var request = new Request(url, {
                    headers
                });

                const response = await fetch(request);
                if (response.ok) {
                    const payload = await response.json();
                    dispatch({ type: RECEIVE_AUTOCOMPLETE_SHORTLIST, payload, isReady, _type });
                } else if (response.status === 401) {
                    getState().auth.isLogin = false;
                }
               
            }
           
            }
        
    },

    requestShortListAnalysis: (isReady) => async (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading) 

        let id = getState().data.selectedShortlist;
        var reload = false;
        if (isReady) {
            reload = getState().data.shortlistAnalysisReady == undefined || getState().data.shortlistAnalysisReady.shortlistId !== getState().data.requestedShortListReady
        } else {
            reload = getState().data.shortlistAnalysis == undefined || getState().data.shortlistAnalysis.shortlistId !== getState().data.requestedShortList
        }
        if (reload) {
            
                dispatch({ type: REQUEST_SHORTLIST_ANALYSIS });
                var headers = new Headers();
                headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
                const url = `api/data/GetShortListDetailById?id=${isReady ? getState().data.selectedShortlistReady : getState().data.selectedShortlist}`;
                var request = new Request(url, {
                    headers
                });

                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type: RECEIVE_SHORTLIST_ANALYSIS, data, isReady });
           
            

           
        }


    },

    updateShortList: () => async (dispatch, getState) => {
        let shortlist = getState().data.shortlistDetail;       
        if (true) {

          
            let data = shortlist;
            dispatch({ type: REQUEST_UPDATE_SHORTLIST });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/UpdateShortList`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();
                dispatch({ type: RECEIVE_UPDATE_SHORTLIST, data });
            } catch (e) {
                console.error(e);
            }
        }

    }
    ,
    setTab: (tab) => (dispatch) => {
        console.info(tab);
        dispatch({ type: SET_TAB, tab: tab });
    },
    setTabSync: (tab) => (dispatch) => {
       
        dispatch({ type: SET_TAB_SYNC, tab: tab });
    },
    ModifyShortList: () => (dispatch) => {
        dispatch({ type: MODIFY_SHORTLIST });
    },
    SetShortlist: (shortlist,isReady) => (dispatch) => {
        dispatch({ type: SET_SHORTLIST, shortlist: shortlist, isReady:isReady});
    },
    SetShortlistByState: (shortlist, _type) => (dispatch) => {
        dispatch({ type: SET_SHORTLIST_BY_STATE, shortlist: shortlist, _type: _type });
    },
    sortTempTracks: (tracks) => (dispatch) => {
        dispatch({ type: SORT_TEMP_SHORTLIST, tracks: tracks });
    },

    getMLTags: () => async (dispatch, getState) => {

       

        if (getState().data.tagsML.length === 0 && !getState().data.isLoadingMLTags) {
            dispatch({ type: GET_ML_TAGS });
            var headers = new Headers();
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/getTagMyTrackItems`;
            var request = new Request(url, {
                headers
            });


            const response = await fetch(request);
            if (response.ok) {
                const payload = await response.json();
                dispatch({ type: GET_ML_TAGS_SUCCESS, payload });
            } else if (response.status === 401) {
                getState().auth.isLogin = false;
            }
        }
       
    },

    getData: () => async (dispatch, getState) => {
        
            dispatch({ type: GET_DATA_START });
            var headers = new Headers();
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/getdata`;
            var request = new Request(url, {
                headers
            });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: GET_DATA_SUCCESS, payload });
        } else if (response.status === 401) {           
            getState().auth.isLogin = false;
        }
        
      
        
        
         
    },

    setAudioUrl: (url) => async (dispatch) => {
        if (url) 
            dispatch({ type: SET_AUDIOURL, url });
    },

    getQuarterData: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.selectedQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_DATA_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetSummaryByQuarter?quarter=${quarter}`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        const payload = await response.json();
        dispatch({ type: GET_QUARTER_DATA_SUCCESS, quarter, payload });
    },
    getQuarterActivityChart: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.activityQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }
        dispatch({ type: GET_QUARTER_ACTIVITY_CHART_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterChart?quarter=${quarter}`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        const payload = await response.json();
        console.warn(payload);
        dispatch({ type: GET_QUARTER_ACTIVITY_CHART_SUCCESS, quarter, payload });
    },
    getDSPQuarter: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.dspQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_DSP_CHART_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterChartTypes?quarter=${quarter}&type=dsp`;
        var request = new Request(url, {
            headers
        });
        try {
        const response = await fetch(request);
        const payload = await response.json();
            dispatch({ type: GET_QUARTER_DSP_CHART_SUCCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getTerritoryQuarter: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.territoryQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterChartTypes?quarter=${quarter}&type=territory`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_SUCCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }
      
    },
    getAssetProfile: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.requestedISRC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ASSET_PROFILE_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetAssetData?isrc=${isrc}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_ASSET_PROFILE_SUCCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }
      
    },

    getTopsQuarter: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.topsQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_TOPS_QUARTER_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterTops?quarter=${quarter}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_TOPS_QUARTER_SUCCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTerritoryStreamsQuarterChart: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.territoryStreamsQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterTerritoryChartTypes?quarter=${quarter}&type=stream`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTerritoryDownloadsQuarterChart: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.territoryDownloadsQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterTerritoryChartTypes?quarter=${quarter}&type=download`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }

    },

    getTerritoryStreamsChartByIsrc: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.territoryStreamsIsrc) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetTerritoryChartByIsrc?isrc=${isrc}&type=stream`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTerritoryDownloadsChartByIsrc: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.territoryDownloadsIsrc) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetTerritoryChartByIsrc?isrc=${isrc}&type=download`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getDSPIsrc: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.dspISRC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ISRC_DSP_CHART_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetISRCChartTypes?isrc=${isrc}&type=dsp`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_ISRC_DSP_CHART_SUCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getISRCChartBydate: (isrc, chartType,startMonth, startYear, endMonth, endYear) => async (dispatch, getState) => {

        if (isrc === getState().data.chartIsrc && chartType === getState().data.chartIsrcType && startMonth === getState().data.chartIsrcStartMonth
            && startYear === getState().data.chartIsrcStartYear && endYear === getState().data.chartIsrcEndYear && endMonth === getState().data.chartIsrcEndMonth) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ISRC_CHART_DATE_START, isrc, chartType, startMonth, startYear, endMonth, endYear });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetISRCChartBydate?isrc=${isrc}&type=${chartType}&startMonth=${startMonth ? startMonth : ''}&startYear=${startYear}&endMonth=${endMonth ? endMonth : ''}&endYear=${endYear ? endYear:''}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_ISRC_CHART_DATE_SUCESS, isrc, chartType, startMonth, startYear, endMonth, endYear, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getRecipientList: () => async (dispatch, getState) => {

        if (getState().recipientList || getState().recipientListLoading === true) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_IMPERSONATION_LIST_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetRecipients`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();           
            dispatch({ type: GET_IMPERSONATION_LIST_SUCCESS, payload });
        } catch (e) {
            console.error(e);
        }
    },
    setRecipientImpersonation: (id) => async (dispatch, getState) => {

        if (getState().recipientID) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }
        let data = { account_id: id };
        dispatch({ type: SET_IMPERSONATION_LIST_START });
        var headers = new Headers();
        headers.append('Content-type', 'application/json')
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/SetImpersonation`;
        var request = new Request(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: SET_IMPERSONATION_LIST_SUCCESS, id, payload });
        } catch (e) {
            console.error(e);
        }
    },
    
};

   

export const getDataOld = (callback) => {
    return async (dispatch) => {

        var header = {
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
        //axios.defaults.headers.get['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
        try {
            let response = await axios.get(`${SERVER_URL}api/auth/changePassword`, header);
            dispatch({
                type: GET_DATA_SUCCESS,
                payload: response
            });

            if (callback)
                callback({
                    succeed: true,
                    error: ''
                });
        } catch (error) {
            if (callback)
                callback({
                    succeed: false,
                    error: 'something went wrong!'
                });
        }
    }

}












// WEBPACK FOOTER //
// ./src/store/actions/dataActions.js